import { IconPropsType } from '..';

export const BasketballIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 100 100"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3_438)">
      <path
        d="M61.1448 88.4114C62.1698 87.1015 63.1521 85.7573 64.0864 84.3898C69.96 75.785 73.987 66.0639 75.7937 56.1698C76.6648 56.7766 77.4012 57.6787 77.9632 58.8403C80.3634 63.8011 79.3962 72.2068 75.442 80.8322C71.2268 84.3156 66.3479 86.8956 61.1435 88.4128L61.1448 88.4114Z"
        fill="#BBBCBE"
      />
      <path
        d="M69.6096 27.6092C63.9462 26.8211 58.7404 24.0819 53.2625 21.1999C46.849 17.8249 40.2266 14.3415 32.5202 14.0079C37.9321 11.373 43.873 10 49.9747 10C53.7049 10 57.4022 10.5176 60.9717 11.5378C64.7637 16.1018 67.7245 21.6173 69.6109 27.6092H69.6096Z"
        fill="#BBBCBE"
      />
      <path
        d="M74.6478 27.671C73.3591 23.1194 71.5427 18.8588 69.2263 14.9443C72.9249 16.9846 76.313 19.6154 79.2065 22.7047C78.5402 25.6114 77.1003 27.1863 74.6492 27.671H74.6478Z"
        fill="#BBBCBE"
      />
      <path
        d="M49.9748 90C39.4999 90 29.4578 85.8671 21.9946 78.5722C30.7961 77.504 38.8789 71.7798 46.7199 66.2272C54.8894 60.4426 62.6054 54.9779 70.3901 54.9779C70.6347 54.9779 70.8778 54.9834 71.121 54.9944C69.4641 64.3393 65.6747 73.5359 60.1144 81.6821C58.1566 84.549 55.9789 87.2896 53.6322 89.8338C52.4163 89.9437 51.188 90 49.9734 90H49.9748Z"
        fill="#BBBCBE"
      />
      <path
        d="M89.4628 43.4568C85.6872 41.6279 81.406 40.1876 76.6893 39.1619C76.5066 36.8497 76.1961 34.5636 75.7646 32.3462C78.9096 31.6761 81.2714 29.8706 82.725 27.0339C86.1887 31.9507 88.4859 37.55 89.4628 43.4568Z"
        fill="#BBBCBE"
      />
      <path
        d="M19.0707 73.941C18.6819 73.941 18.2903 73.9286 17.9029 73.9025C13.3703 67.8461 10.6774 60.7214 10.0783 53.2067C23.2708 46.9237 38.571 43.049 53.2721 42.2774C55.0486 42.184 56.8264 42.1373 58.5576 42.1373C63.2894 42.1373 67.8303 42.4861 72.0716 43.174C72.1115 45.5013 72.0139 47.8615 71.7803 50.2204C71.3366 50.1929 70.8914 50.1778 70.4462 50.1778C66.7545 50.1778 62.9391 51.1129 58.7815 53.0351C53.731 55.372 48.7532 58.8966 43.9403 62.3045C35.8629 68.0246 27.5094 73.9396 19.0721 73.9396L19.0707 73.941Z"
        fill="#BBBCBE"
      />
      <path
        d="M83.4053 71.972C84.5649 66.0391 84.2035 60.6953 82.2938 56.7464C80.9734 54.0182 78.9922 52.1001 76.5205 51.1403C76.7678 48.7993 76.8915 46.4528 76.8901 44.1337C81.8885 45.3228 86.2851 47.0157 89.9906 49.1782C89.9974 49.4693 90.0002 49.7412 90.0002 49.9993C90.0002 57.8805 87.692 65.4844 83.4053 71.9706V71.972Z"
        fill="#BBBCBE"
      />
      <path
        d="M10.0014 47.9439C10.549 37.3523 15.3148 27.3552 23.2732 20.2181C26.0074 19.2474 28.6483 18.7751 31.3359 18.7751C38.3074 18.7751 44.4636 22.0182 50.9821 25.4508C57.1493 28.6994 63.5168 32.0524 70.8438 32.57C70.8603 32.6483 70.8768 32.7251 70.8918 32.802L70.9673 33.1755C71.2927 34.8328 71.5452 36.5408 71.7209 38.2681C67.5289 37.6447 63.0858 37.3303 58.4889 37.3303C56.6812 37.3303 54.8268 37.3797 52.9765 37.4772C38.435 38.242 23.2649 41.9437 10 47.9425L10.0014 47.9439Z"
        fill="#BBBCBE"
      />
      <path
        d="M69.6094 27.6092C63.946 26.8211 58.7402 24.0819 53.2623 21.1999C46.8488 17.8249 40.2264 14.3415 32.52 14.0079C37.9319 11.373 43.8728 10 49.9745 10C53.7047 10 57.402 10.5176 60.9715 11.5378C64.7635 16.1018 67.7243 21.6173 69.6107 27.6092H69.6094Z"
        fill="#BBBCBE"
      />
      <path
        d="M74.6476 27.671C73.3589 23.1194 71.5425 18.8588 69.2261 14.9443C72.9247 16.9846 76.3128 19.6154 79.2063 22.7047C78.54 25.6114 77.1001 27.1863 74.649 27.671H74.6476Z"
        fill="#BBBCBE"
      />
    </g>
    <defs>
      <clipPath id="clip0_3_438">
        <rect
          width="100"
          height="100"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
